// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import inbox01Icon from "@/assets/icons/inbox-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Inbox01IconProps = Omit<IconProps, "name">;

export function Inbox01Icon(props: Inbox01IconProps): React.ReactNode {
  return <Icon name={inbox01Icon} {...props} />;
}
